module.exports = __webpack_public_path__ + "img/mz_title.c3ba4a7e.png";